import { NotificationBarContextControllerProps } from './NotificationBarContextController.types'
import { NotificationBarContext } from '../notificationBarContext/NotificationBarContext'
import { useState } from 'react'

export function NotificationBarContextController({ children }: NotificationBarContextControllerProps) {
  const [isOpened, setIsOpened] = useState(false)
  return <NotificationBarContext.Provider value={{ isOpened, setIsOpened }}>{children}</NotificationBarContext.Provider>
}
